import React, { useState } from 'react';
import styles from './Footer.module.css';
import FooterBrand from './FooterBrand';
import FooterNav from './FooterNav';
import Icon from '../../common/Icon/Icon';
import { FOOTER_BRAND, FOOTER_NAV } from '../../../constants/footer';
import TermsModal from '../../../shared/terms/TermsModal';
import ServiceTerms from '../../../shared/terms/ServiceTerms';
import PrivacyPolicy from '../../../shared/terms/PrivacyPolicy';
import MarketingConsent from '../../../shared/terms/MarketingConsent';
import AiTrainingConsent from '../../../shared/terms/AiTrainingConsent';

/**
 * @component Footer
 * @description 전역 Footer 컴포넌트
 */
const MODAL_MAP = {
  terms: { title: '서비스 이용약관', content: ServiceTerms },
  privacy: { title: '개인정보처리방침', content: PrivacyPolicy },
  marketing: { title: '개인정보 수집·이용 및 제3자 제공 동의', content: MarketingConsent },
  aiTraining: { title: 'AI 학습·모델 고도화 동의', content: AiTrainingConsent },
};

function Footer({ dark = false }) {
  const [modal, setModal] = useState(null);

  const handleModalOpen = (key) => {
    const data = MODAL_MAP[key];
    if (data) setModal(data);
  };

  return (
    <footer className={dark ? styles.footerDark : styles.footer}>
      <div className={styles.container}>
        <div className={styles.main}>
          <FooterBrand tagline={FOOTER_BRAND.tagline} />
          <FooterNav columns={FOOTER_NAV} onModalOpen={handleModalOpen} />
        </div>
      </div>

      <div style={{ width: '100%', boxSizing: 'border-box', padding: '32px 32px 0 32px' }}>
        <hr className={styles.divider} />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <p style={{ fontFamily: 'Pretendard, sans-serif', fontSize: '12px', color: '#888896', margin: 0 }}>
              <span style={{ whiteSpace: 'nowrap' }}>(주) 퍼니즈 (Pawnies Co., Ltd)</span>
              {' '}&nbsp;|&nbsp;{' '}
              <span style={{ whiteSpace: 'nowrap' }}>대표이사 : 김필겸</span>
              {' '}&nbsp;|&nbsp;{' '}
              <span style={{ whiteSpace: 'nowrap' }}>사업자등록번호 : 679-81-03855</span>
            </p>
            <p style={{ fontFamily: 'Pretendard, sans-serif', fontSize: '12px', color: '#888896', margin: 0 }}>
              <span style={{ whiteSpace: 'nowrap' }}>통신판매업 신고번호 : 신고 준비 중</span>
              {' '}&nbsp;|&nbsp;{' '}
              <span style={{ whiteSpace: 'nowrap' }}>사업장 소재지 : 경상북도 포항시 북구 흥해읍 한동로 558, 창업보육센터 302호</span>
            </p>
            <p style={{ fontFamily: 'Pretendard, sans-serif', fontSize: '12px', color: '#888896', margin: 0 }}>
              <span style={{ whiteSpace: 'nowrap' }}>고객센터 : 054-262-2930</span>
              {' '}&nbsp;|&nbsp;{' '}
              <span style={{ whiteSpace: 'nowrap' }}>이메일 : castar.korea@gmail.com</span>
            </p>
            <p style={{ fontFamily: 'Pretendard, sans-serif', fontSize: '12px', color: '#888896', margin: '4px 0 0 0' }}>{FOOTER_BRAND.copyright}</p>
          </div>
          <div className={styles.socialLinks}>
            <a href="https://www.instagram.com/castar_official/" className={styles.socialLink} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <Icon name="instagram" size="22" />
            </a>
            <a href="http://pf.kakao.com/_xanYxdX" className={styles.socialLink} target="_blank" rel="noopener noreferrer" aria-label="카카오톡">
              <Icon name="kakao" size="22" />
            </a>
          </div>
        </div>
      </div>
      {modal && (
        <TermsModal
          title={modal.title}
          content={modal.content}
          onClose={() => setModal(null)}
        />
      )}
    </footer>
  );
}

export default Footer;